import { render, staticRenderFns } from "./page-landing.vue?vue&type=template&id=da5e95c0&scoped=true"
import script from "./page-landing.vue?vue&type=script&lang=js"
export * from "./page-landing.vue?vue&type=script&lang=js"
import style0 from "./page-landing.vue?vue&type=style&index=0&id=da5e95c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e95c0",
  null
  
)

export default component.exports